import { defaultBgImgId } from 'src/consumer/constants'

export function modifyQusAnsDataArray(orignalQusAnsArray) {
  const modifiedQusAnsDataArray = orignalQusAnsArray?.map((qusAnsItem, index) => {
    if (
      qusAnsItem?.questionType === 'comparative' &&
      qusAnsItem?.answerType === 'option-select-single' &&
      qusAnsItem?.comparative1 &&
      qusAnsItem?.comparative2
    ) {
      const newOrderedOptionsArray = []
      const sortedOptionsOnUserId = qusAnsItem?.options?.sort((a, b) => {
        if (a?.orderId < b?.orderId) return -1
        if (a?.orderId > b?.orderId) return 1
        return 0
      })
      sortedOptionsOnUserId?.forEach((optionItem) => {
        newOrderedOptionsArray?.push({
          ...optionItem,
          comparative: 'comparative1',
          comparative1: qusAnsItem?.comparative1,
          comparative2: qusAnsItem?.comparative2,
        })
      })

      newOrderedOptionsArray?.push({ extraOption: true })

      sortedOptionsOnUserId?.toReversed()?.forEach((optionItem) => {
        newOrderedOptionsArray?.push({
          ...optionItem,
          comparative: 'comparative2',
          comparative1: qusAnsItem?.comparative1,
          comparative2: qusAnsItem?.comparative2,
        })
      })
      return { ...qusAnsItem, options: newOrderedOptionsArray }
    }
    return qusAnsItem
  })
  return modifiedQusAnsDataArray
}

export function getListItemsForAssessments(activityPlans) {
  return activityPlans?.map((activityPlanItem) => ({
    id: activityPlanItem?.assessmentId,
    imageId: activityPlanItem?.coverIcon || defaultBgImgId,
    link: '/workplace/webinars',
    slug: activityPlanItem?.slug,
    title: activityPlanItem?.title,
    description: activityPlanItem?.description,
  }))
}
